(() => {
  if (window.themeMembershipFeaturesBound) return;
  window.themeMembershipFeaturesBound = true;
  const observers = new Map();
  const init = (root) => {

    if (!root || root.dataset.motionInitialized === 'true') return;
    root.dataset.motionInitialized = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      root.classList.add('rliab-ambient-visible');
      return;
    }

    const reveal = (element, delay = 0) => {
      if (!element || element.classList.contains('is-visible')) return;

      element.style.setProperty('--rliab-motion-delay', `${delay}ms`);

      requestAnimationFrame(() => {
        element.classList.add('is-visible');
      });
    };

    const register = (element, extraClass = '') => {
      if (!element) return null;

      element.classList.add('rliab-motion-item');

      extraClass.split(' ').forEach((className) => {
        if (className) element.classList.add(className);
      });

      return element;
    };

    const headerEyebrow = register(
      root.querySelector('.rliab-aura-compare__eyebrow'),
      'rliab-motion-soft'
    );

    const title = register(
      root.querySelector('.rliab-aura-compare__title')
    );

    const intro = register(
      root.querySelector('.rliab-aura-compare__header-copy'),
      'rliab-motion-soft'
    );

    const plans = Array.from(
      root.querySelectorAll('.rliab-aura-compare__plan')
    ).map((element) => register(element, 'rliab-motion-scale'));

    const comparisonShell = register(
      root.querySelector('.rliab-aura-compare__comparison-shell'),
      'rliab-motion-scale'
    );

    const tableHead = register(
      root.querySelector('.rliab-aura-compare__table-head'),
      'rliab-motion-soft'
    );

    const groups = Array.from(
      root.querySelectorAll('.rliab-aura-compare__group')
    ).map((element) => register(element, 'rliab-motion-soft'));

    const rows = Array.from(
      root.querySelectorAll('.rliab-aura-compare__row')
    ).map((element) => register(element, 'rliab-motion-soft'));

    const footer = register(
      root.querySelector('.rliab-aura-compare__footer'),
      'rliab-motion-soft'
    );

    /*
      Apply the hidden start state only after all targets are registered.
      That avoids partially hidden content during initialization.
    */
    root.classList.add('rliab-motion-ready');

    requestAnimationFrame(() => {
      root.classList.add('rliab-ambient-visible');

      reveal(headerEyebrow, 35);
      reveal(title, 95);
      reveal(intro, 155);

      plans.forEach((plan, index) => {
        reveal(plan, 205 + (index * 85));
      });
    });

    if (!('IntersectionObserver' in window)) {
      [comparisonShell, tableHead, ...groups, ...rows, footer].forEach((element, index) => {
        reveal(element, Math.min(index * 18, 180));
      });
      return;
    }

    const observer = new IntersectionObserver((entries, instance) => {
      const entering = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

      entering.forEach((entry, index) => {
        const element = entry.target;
        let delay = 0;

        if (element.classList.contains('rliab-aura-compare__row')) {
          delay = Math.min(index * 28, 112);
        } else if (element.classList.contains('rliab-aura-compare__group')) {
          delay = 25;
        }

        reveal(element, delay);
        instance.unobserve(element);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });

    [comparisonShell, tableHead, ...groups, ...rows, footer].forEach((element) => {
      if (element) observer.observe(element);
    });

    observers.set(root, observer);

  };
  const scan = (scope = document) => scope.querySelectorAll('[id^="rliab-aura-compare-"]').forEach(init);
  document.addEventListener('shopify:section:unload', event => {
    observers.forEach((observer, root) => {
      if (event.target?.contains(root)) {
        observer.disconnect();
        observers.delete(root);
        delete root.dataset.motionInitialized;
      }
    });
  });
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
